import { fixedTop } from '../functions/fixed-top.js';

document.addEventListener("DOMContentLoaded", () => {

    fixedTop();
    const menuBtn = document.querySelector(".menu-btn");
    const menuMobile = document.querySelector(".menu-mobile");
    const body = document.querySelector("body");
    const menuLinks = document.querySelectorAll(".menu-mobile a");
    
    // Selecciona todos los encabezados de submenú
    const submenuHeaders = document.querySelectorAll('.menu__item--sub-menu > .menu__item__header');
    const subsubmenuHeaders = document.querySelectorAll('.menu__sub-item--sub-menu > .menu__item__header');
    
    // Función para cerrar todos los submenús abiertos
    function closeAllSubmenus() {
        const openSubmenus = document.querySelectorAll('.menu__sub-menu.open');
        openSubmenus.forEach(submenu => {
            submenu.classList.remove('open');
            submenu.style.display = 'none';
    
            // Remover clase 'nav-underline' del título correspondiente
            submenu.previousElementSibling.querySelector('.menu__item__title').classList.remove('nav-underline');
        });
    }
    
    // Función para cerrar todos los sub-submenús abiertos
    function closeAllSubsubmenus() {
        const openSubsubmenus = document.querySelectorAll('.menu__sub-sub-menu.open');
        openSubsubmenus.forEach(subsubmenu => {
            subsubmenu.classList.remove('open');
            subsubmenu.style.display = 'none';
    
            // Remover clase 'nav-underline' del título correspondiente
            subsubmenu.previousElementSibling.querySelector('.menu__item__title').classList.remove('nav-underline');
        });
    }
    
    // Función para cerrar todos los menús (submenús y sub-submenús)
    function closeAllMenus() {
        closeAllSubmenus();
        closeAllSubsubmenus();
    }

    menuLinks.forEach(link => {
        link.addEventListener('click', () => {
            // Remover la clase "open" cuando se hace clic en un enlace
            menuBtn.classList.remove("open");
            menuMobile.classList.remove("open");
        menuBtn.classList.toggle("close");
        });
    });

    // Evento para el botón del menú
    menuBtn.addEventListener('click', () => {
        menuBtn.classList.toggle("close");
        menuMobile.classList.toggle("open");
        body.classList.toggle("stop-scrolling");
    
        if (!menuMobile.classList.contains('open')) {
            closeAllMenus(); // Cierra todos los menús cuando el menú móvil se cierra
        }
    });
    
    // Añadir evento a cada encabezado de submenú
    submenuHeaders.forEach(header => {
        header.addEventListener('click', () => {
            const submenu = header.nextElementSibling; // El submenú que sigue al encabezado
            const title = header.querySelector('.menu__item__title');
    
            if (submenu.classList.contains('open')) {
                submenu.classList.remove('open');
                title.classList.remove('nav-underline'); // Quita la clase 'nav-underline'
            } else {
                closeAllSubmenus(); // Cierra otros submenús
                closeAllSubsubmenus(); // Cierra todos los sub-submenús abiertos
                submenu.classList.add('open');
                title.classList.add('nav-underline'); // Añade la clase 'nav-underline'
            }
        });
    });
    
    // Añadir evento a cada encabezado de sub-submenú
    subsubmenuHeaders.forEach(header => {
        header.addEventListener('click', (event) => {
            event.stopPropagation(); // Evita que el evento burbujee y cierre el submenú padre
            const subsubmenu = header.nextElementSibling; // El sub-submenú que sigue al encabezado
            const title = header.querySelector('.menu__item__title');
    
            if (subsubmenu.classList.contains('open')) {
                subsubmenu.classList.remove('open');
                title.classList.remove('nav-underline'); // Quita la clase 'nav-underline'
            } else {
                closeAllSubsubmenus(); // Cierra otros sub-submenús
                subsubmenu.classList.add('open');
                title.classList.add('nav-underline'); // Añade la clase 'nav-underline'
            }
        });
    });
    
    
    
    
});
